import axios from 'axios'
import { LocalStorageService } from '../services'

class InvoiceService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()

  /**
  * @author Lucia Alvarado
  * @description Create a new invoice in the table invoice of A3Cloud
  * @date 10-11-2020
  * @param {String} token
  * @param {Object} invoice
  * @returns {Object}
  * @memberof TaxDataService
  */
   async createInvoice ( invoice, token ) {
    let { contractId, organization, rfc, street, number, colony, township, state, zipCode, invoiceComboId, planLevelId, invoiceMonth  } = invoice
  
    let response = await axios.post(`${this.apiUrl}/invoice`, {
      contract: contractId, 
      clientName: organization,
      rfc,
      street,
      number,
      colony,
      township,
      state,
      zipCode,
      invoiceUsePersonTypeId: invoiceComboId, 
      planLevelId, 
      invoiceMonth
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    
    return response.data.data
  }

}

export { InvoiceService as default }
